import React from "react";
import { checkAccessList } from "../common/utilities";
import CustomTabs from "../components/CustomTabs";
import EmployeeSearch from "./EmployeeSearch";
import AddEmployee from "./AddEmployee";
import "./styles.css";

const EmployeeManagement = () => {
  const tabs = [
    { title: "Employee Search", key: "search", content: <EmployeeSearch /> },
    ...(checkAccessList("crud_employee")
      ? [{ title: "Add Employee", key: "add", content: <AddEmployee /> }]
      : []),
  ];

  return (
    <div className="page-wrap">
      <CustomTabs tabs={tabs} />
    </div>
  );
};

export default EmployeeManagement;
